<template><svg width="8" height="9" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="4.5" r="4" fill="#CEE000"/></svg></template>